import "@hotwired/turbo-rails"
import { Application } from "@hotwired/stimulus"
import htmx from "htmx.org"

// TurboとHTMXの競合を解決
document.addEventListener('DOMContentLoaded', function() {
  if (typeof Turbo !== 'undefined') {
    // Turbo-Frameの無効化はhtmx_config.jsで処理
  }
});
import "../controllers"
import "chartkick"
import { Chart, registerables } from "chart.js"
Chart.register(...registerables)

// Make Chart available globally for chartkick
window.Chart = Chart
// Ensure htmx is available when bundled via Webpack
window.htmx = htmx
// Enable HTMX debug mode (disabled in production)
// htmx.config.debug = true
import "../htmx_config"
import "./application.scss"
import "../custom/form_run_enhancer"
import "../custom/admin_select2"
import jquery from "jquery"
import "@popperjs/core"
import "bootstrap"
import React from "react"
import { createRoot } from "react-dom/client"

import ReactRailsUJS from "react_ujs"
const componentRequireContext = require.context("../components", true)
ReactRailsUJS.useContext(componentRequireContext)

// Turbo DriveではDOMContentLoadedが発火しないため、Reactのマウント/アンマウントをTurboイベントに紐付ける
ReactRailsUJS.handleEvent("turbo:before-render", ReactRailsUJS.handleUnmount)
ReactRailsUJS.handleEvent("turbo:before-cache", ReactRailsUJS.handleUnmount)
ReactRailsUJS.handleEvent("turbo:load", ReactRailsUJS.handleMount)

// Turboの初回読み込みでもturbo:loadが発火するため、重複マウントを避ける
if (ReactRailsUJS.removeEvent) {
  ReactRailsUJS.removeEvent("DOMContentLoaded", ReactRailsUJS.handleMount)
}

// Expose shared globals needed by legacy code
window.$ = window.jQuery = jquery
Chart.register(...registerables)
window.Chart = Chart
// Expose React globally for debugging
window.React = React

// Cross Landing Page Admin
import CrossLandingPageAdmin from '../components/CrossLandingPageEditor'

const mountCrossLandingPageAdmin = () => {
  const container = document.getElementById('cross-landing-page-admin')
  if (container && !container.dataset.mounted) {
    const initialData = window.crossLandingPageInitialData || []
    const initialPagination = window.crossLandingPagePagination || null
    const apiBaseUrl = container.dataset.apiBaseUrl || '/admin/cross_landing_pages'
    const csrfToken = container.dataset.csrfToken || ''

    const root = createRoot(container)
    root.render(
      React.createElement(CrossLandingPageAdmin, {
        initialData,
        initialPagination,
        apiBaseUrl,
        csrfToken,
      })
    )
    container.dataset.mounted = 'true'
  }
}

document.addEventListener('DOMContentLoaded', mountCrossLandingPageAdmin)
document.addEventListener('turbo:load', mountCrossLandingPageAdmin)

// Stimulusアプリケーションの初期化
window.Stimulus = Application.start()

// Bootstrapとhtmxをturbo:loadで初期化
document.addEventListener('turbo:load', function() {
  // Bootstrapの初期化
  if (typeof bootstrap !== 'undefined') {
    // 全てのBootstrapコンポーネントを再初期化
    const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    tooltipTriggerList.map(function (tooltipTriggerEl) {
      return new bootstrap.Tooltip(tooltipTriggerEl)
    })
    
    const popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
    popoverTriggerList.map(function (popoverTriggerEl) {
      return new bootstrap.Popover(popoverTriggerEl)
    })
    
    // Collapseコンポーネントの初期化
    const collapseElementList = [].slice.call(document.querySelectorAll('.collapse'))
    collapseElementList.map(function (collapseEl) {
      return new bootstrap.Collapse(collapseEl, { toggle: false })
    })
    
    // Navbar togglerの手動初期化
    const navbarTogglers = document.querySelectorAll('.navbar-toggler')
    navbarTogglers.forEach(function(toggler) {
      toggler.addEventListener('click', function(e) {
        e.preventDefault()
        const target = document.querySelector(toggler.getAttribute('data-bs-target'))
        if (target) {
          const collapse = bootstrap.Collapse.getOrCreateInstance(target)
          collapse.toggle()
          
          // aria-expanded属性を更新
          const isExpanded = target.classList.contains('show')
          toggler.setAttribute('aria-expanded', isExpanded)
          
          // collapseイベントリスナーを追加
          target.addEventListener('shown.bs.collapse', function() {
            toggler.setAttribute('aria-expanded', 'true')
          })
          
          target.addEventListener('hidden.bs.collapse', function() {
            toggler.setAttribute('aria-expanded', 'false')
          })
        }
      })
    })
  }
  
  // htmxの初期化
  if (typeof htmx !== 'undefined') {
    htmx.process(document.body);
  }
});

// DOMContentLoadedでも初期化（初回読み込み時）
document.addEventListener('DOMContentLoaded', function() {
  // HTMXの初期化
  if (typeof htmx !== 'undefined') {
    htmx.process(document.body);
  }
  
  // Bootstrapの初期化
  if (typeof bootstrap !== 'undefined') {
    const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    tooltipTriggerList.map(function (tooltipTriggerEl) {
      return new bootstrap.Tooltip(tooltipTriggerEl)
    })
    
    const popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
    popoverTriggerList.map(function (popoverTriggerEl) {
      return new bootstrap.Popover(popoverTriggerEl)
    })
    
    const collapseElementList = [].slice.call(document.querySelectorAll('.collapse'))
    collapseElementList.map(function (collapseEl) {
      return new bootstrap.Collapse(collapseEl, { toggle: false })
    })
    
    // Navbar togglerの手動初期化
    const navbarTogglers = document.querySelectorAll('.navbar-toggler')
    navbarTogglers.forEach(function(toggler) {
      toggler.addEventListener('click', function(e) {
        e.preventDefault()
        const target = document.querySelector(toggler.getAttribute('data-bs-target'))
        if (target) {
          const collapse = bootstrap.Collapse.getOrCreateInstance(target)
          collapse.toggle()
          
          // aria-expanded属性を更新
          const isExpanded = target.classList.contains('show')
          toggler.setAttribute('aria-expanded', isExpanded)
          
          // collapseイベントリスナーを追加
          target.addEventListener('shown.bs.collapse', function() {
            toggler.setAttribute('aria-expanded', 'true')
          })
          
          target.addEventListener('hidden.bs.collapse', function() {
            toggler.setAttribute('aria-expanded', 'false')
          })
        }
      })
    })
  }
});
